import React from 'react';
import { LayoutPage } from 'components/layouts';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './style.css';

const antIcon = <LoadingOutlined style={{ fontSize: 100 }} spin />;
const LoadingFullPage = () => {
  return (
    <LayoutPage className="loading-page" header={false} footer={false}>
      <LayoutPage.Container className="wrapper">
        <Spin indicator={antIcon} />
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default LoadingFullPage;
